import { ApprovalInfo, ApprovalStatus } from '@data/course/approval/approval';
import React from 'react';

interface CompletedChecklistProps {
  courseApproval: ApprovalInfo;
  curriculumApproval: ApprovalInfo;
}

const statusToMessage = (status: ApprovalStatus, type: string) => {
  switch (status) {
    case ApprovalStatus.Approved:
      return `Congratulations! Your ${type} has been approved.`;
    case ApprovalStatus.Flag:
      return (
        `Congratulations! Your ${type} has been approved. ` +
        `However, you have also been instructed to meet ` +
        `with your chapter president. Please do so ASAP`
      );
    case ApprovalStatus.Denied:
      return `Unfortunately, your ${type} has been denied.`;
    case ApprovalStatus.NoReview:
      return `Your ${type} hasn't been reviewed yet. Please check back later.`;
  }
};

const CompletedChecklist: React.FC<CompletedChecklistProps> = ({
  courseApproval,
  curriculumApproval,
}) => {
  const courseText = statusToMessage(courseApproval.status, 'course information');
  const curriculumText = statusToMessage(curriculumApproval.status, 'curriculum');

  return (
    <div className='w-full mb-4'>
      <div className='mb-4'>
        <p className='text-lg'>
          <strong>Course Information</strong>: {courseText}
        </p>
        {courseApproval.comments ? (
          <p>
            The following comments have been left on your course proposal: {courseApproval.comments}
          </p>
        ) : null}
      </div>
      <div className='mb-4'>
        <p className='text-lg'>
          <strong>Curriculum</strong>: {curriculumText}
        </p>
        {curriculumApproval.comments ? (
          <p>
            The following comments have been left on your curriculum: {curriculumApproval.comments}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default CompletedChecklist;
